import { InternshipLocationsService } from 'data/services';
import { InternshipLocationsServiceInterface } from 'domain/services';
import { makeRemoteCreateInternshipLocation } from 'main/factories/usecases/InternshipLocations/create-internship-location-factory';
import { makeRemoteDeleteInternshipLocation } from 'main/factories/usecases/InternshipLocations/delete-internship-location-factory';
import { makeRemoteDeleteInternshipLocationImage } from 'main/factories/usecases/InternshipLocations/delete-internship-location-image-factory';
import { makeRemoteGetAllInternshipLocations } from 'main/factories/usecases/InternshipLocations/get-all-internship-locations-factory';
import { makeRemoteGetInternshipLocationById } from 'main/factories/usecases/InternshipLocations/get-internship-location-by-id-factory';
import { makeRemoteUpdateInternshipLocation } from 'main/factories/usecases/InternshipLocations/update-internship-location-factory';
import { makeRemoteUpdateInternshipLocationImage } from 'main/factories/usecases/InternshipLocations/update-internship-location-image-factory';
import { makeRemoteVerifyInternshipResponsibleEmail } from 'main/factories/usecases/InternshipLocations/verify-internship-respnsible-email-factory';
import { makeRemoteVerifyInternshipResponsibleCpf } from 'main/factories/usecases/InternshipLocations/verify-internship-responsible-cpf-factory';

export const makeInternshipLocationsService =
  (): InternshipLocationsServiceInterface => {
    return new InternshipLocationsService({
      getAllInternshipLocations: makeRemoteGetAllInternshipLocations(),
      createInternshipLocation: makeRemoteCreateInternshipLocation(),
      updateInternshipLocation: makeRemoteUpdateInternshipLocation(),
      deleteInternshipLocation: makeRemoteDeleteInternshipLocation(),
      getInternshipLocationById: makeRemoteGetInternshipLocationById(),
      verifyInternshipResponsibleCpf:
        makeRemoteVerifyInternshipResponsibleCpf(),
      verifyInternshipResponsibleEmail:
        makeRemoteVerifyInternshipResponsibleEmail(),
      updateInternshipLocationImage: makeRemoteUpdateInternshipLocationImage(),
      deleteInternshipLocationImage: makeRemoteDeleteInternshipLocationImage(),
    });
  };
